@if (control?.touched) {
  @if (result) {
    <div class="mb-2">
      <mat-progress-bar [value]="(result.score / 4) * 100" [color]="color" />
      <div class="d-flex justify-content-between mt-1">
        <small class="text-muted">{{ label }}</small>
        <small class="text-muted">{{ result.score }}/4</small>
      </div>
      @if (result.feedback.warning) {
        <small class="text-warning d-block">{{ result.feedback.warning }}</small>
      }
      @for (suggestion of result.feedback.suggestions; track suggestion) {
        <small class="text-muted d-block">• {{ suggestion }}</small>
      }
    </div>
  }
  
  @if (control?.errors) {
    <ul class="list-unstyled mt-1">

      <small class="d-flex"
          [class.text-success]="!control.errors?.['minLength']"
          [class.text-danger]="control.errors?.['minLength']">
        <mat-icon>{{ control.errors?.['minLength'] ? 'close' : 'check' }}</mat-icon> At least 12 characters
      </small>
      <small class="d-flex"
          [class.text-success]="!control.errors?.['hasUppercase']"
          [class.text-danger]="control.errors?.['hasUppercase']">
        <mat-icon>{{ control.errors?.['hasUppercase'] ? 'close' : 'check' }}</mat-icon> One uppercase letter
      </small>
      <small class="d-flex"
          [class.text-success]="!control.errors?.['hasLowercase']"
          [class.text-danger]="control.errors?.['hasLowercase']">
        <mat-icon>{{ control.errors?.['hasLowercase'] ? 'close' : 'check' }}</mat-icon> One lowercase letter
      </small>
      <small class="d-flex"
          [class.text-success]="!control.errors?.['hasNumber']"
          [class.text-danger]="control.errors?.['hasNumber']">
        <mat-icon>{{ control.errors?.['hasNumber'] ? 'close' : 'check' }}</mat-icon> One number
      </small>
      <small class="d-flex"
          [class.text-success]="!control.errors?.['hasSpecial']"
          [class.text-danger]="control.errors?.['hasSpecial']">
        <mat-icon>{{ control.errors?.['hasSpecial'] ? 'close' : 'check' }}</mat-icon> One special character
      </small>
  
    </ul>
  }
}
